module.exports = "<div class=\"dragger\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/scrollbar.hbs
// module id = 711
// module chunks = 0